import React from "react";
import {connect} from "react-redux";
import queryString from "query-string";
import { NumericFormat as NumberFormat } from "react-number-format";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Col, Modal, Row, Tab, Tabs} from "react-bootstrap";
import {Link} from "react-router-dom";
import ventaService from "../../../../_services/cart/ventaService";
import {ESTADO_VENTA, LoadingBoton, MEDIO_PAGO, TIPO_ENVIO} from "../../../../_helpers";
import {NavBarLateral} from "../../NavBarLateral";
import {productoActions} from "../../../../_actions";
import authService from "../../../../_services/cart/authService";
import {ventasService} from "../../../../_services";
import {ReviewModal} from "./ReviewModal";
import alertService from "../../../../_services/cart/alert.service";
import {busquedaActions} from "../../../../_actions/busqueda.actions";
import productoServiceTs from "../../../../_services/cart/producto.service";
import {ComprobanteTransferencia} from "./ComprobanteTransferencia";
import Moment from "react-moment";
import {estadoDeVenta} from "./estadosVenta";
import {redondearMonto} from "../../../publica/utils/Oferta";
import facturacionService from "../../../../_services/cart/facturacion.service";
import {FacturaVenta} from "./FacturaVenta";

class CompraDetail extends React.Component {
    state = {
        venta: undefined,
        error: undefined,
        itemVenta: undefined,
        showReview: false,
        readonly: false,
        facturacionHabilitada: false,
    };

    componentDidMount() {
        let params = queryString.parse(this.props.location.search);

        // "Facturar" se ofrece solo con ARCA integrado y probado (y a quien tiene el permiso).
        if (authService.hasPermiso("FACTURACION")) {
            facturacionService.habilitada().then((h) => this.setState({facturacionHabilitada: h}));
        }

        ventaService.getVentaComprador(params.id, this.setVenta);
    }

    addReview = (ventaReview) => {
        this.setState({ventaReview: ventaReview, showReview: true, readonly: false});
    };

    viewReview = (ventaReview) => {
        this.setState({ventaReview: ventaReview, showReview: true, readonly: true});
    };

    handleCloseReview = () => {
        this.setState({showReview: false, ventaReview: undefined, readonly: false});
    };

    handleClose = () => {
        this.setState({showReview: false, ventaReview: undefined});

        let params = queryString.parse(this.props.location.search);
        ventaService.getVentaComprador(params.id, this.setVenta);
    };

    /** Lo devuelve el POST del comprobante; evita recargar toda la venta. */
    setComprobante = (comprobanteUrl) => {
        this.setState((prev) => ({
            venta: {
                ...prev.venta,
                comprobanteUrl: comprobanteUrl,
                comprobanteFecha: new Date().toISOString(),
            },
        }));
    };

    setVenta = (data) => {
        if (data.error) {
            this.setState({error: data.error});
        } else {
            this.setState({venta: data.venta});
        }
    };

    cancelarVenta = (esVendedor) => {
        if (esVendedor) {
            ventasService
                .cambiarEstadoVendedor({
                    id: this.state.venta.id,
                    estado: ESTADO_VENTA.CANCELADA,
                })
                .then((data) => {
                    let venta = this.state.venta;
                    venta.estado = ESTADO_VENTA.CANCELADA;
                    this.setState({venta: venta});
                })
                .catch((error) => {
                    alertService.error(error);
                });
        } else {
            ventasService
                .cambiarEstadoComprador({
                    id: this.state.venta.id,
                    estado: ESTADO_VENTA.CANCELADA,
                })
                .then((data) => {
                    let venta = this.state.venta;
                    venta.estado = ESTADO_VENTA.CANCELADA;
                    this.setState({venta: venta});
                })
                .catch((error) => {
                    alertService.error(error);
                });
        }
    };

    marcarComoPagada = () => {
        ventasService
            .cambiarEstadoVendedor({
                id: this.state.venta.id,
                estado: ESTADO_VENTA.PAGADA,
            })
            .then((data) => {
                let venta = this.state.venta;
                venta.estado = ESTADO_VENTA.PAGADA;
                this.setState({venta: venta});
            })
            .catch((error) => {
                alertService.error(error);
            });
    };

    marcarComoEnviada = () => {
        ventasService
            .cambiarEstadoVendedor({
                id: this.state.venta.id,
                estado: ESTADO_VENTA.PENDIENTE_ENTREGA,
            })
            .then((data) => {
                let venta = this.state.venta;
                venta.estado = ESTADO_VENTA.PENDIENTE_ENTREGA;
                this.setState({venta: venta});
            })
            .catch((error) => {
                alertService.error(error);
            });
    };

    marcarComoFinalizada = () => {
        ventasService
            .cambiarEstadoVendedor({
                id: this.state.venta.id,
                estado: ESTADO_VENTA.FINALIZADA,
            })
            .then((data) => {
                let venta = this.state.venta;
                venta.estado = ESTADO_VENTA.FINALIZADA;
                this.setState({venta: venta});
            })
            .catch((error) => {
                alertService.error(error);
            });
    };


    toogleActivo = () => {
        ventasService
            .cambiarEstadoVendedor({
                id: this.state.venta.id,
                estado: ESTADO_VENTA.FINALIZADA,
            })
            .then((data) => {
                let venta = this.state.venta;
                venta.estado = ESTADO_VENTA.FINALIZADA;
                this.setState({venta: venta});
            })
            .catch((error) => {
                alertService.error(error);
            });
    };

    render() {
        const {venta, error} = this.state;

        const soyAdmin = authService.hasAuthority("ADMIN");

        // Con el vendedor efectivo: un empleado de la cuenta tambien es "el vendedor" de la venta.
        const soyVendedorEnVenta = authService.vendedorEfectivoId() === venta?.vendedor?.id;

        const estadoFlujo = estadoDeVenta(venta?.estado);

        return (
            <>
                <div className="dashboard">
                    <NavBarLateral handleClose={this.handleClose}/>
                    <div className="dashboard__content">
                        {venta === undefined && (
                            <Row>
                                <Col>
                                    <LoadingBoton grabando={true}></LoadingBoton>
                                </Col>
                            </Row>
                        )}

                        {error !== undefined && (
                            <Row>
                                <Col>
                                    Existe un error con la venta seleccionada:
                                    {error}
                                </Col>
                            </Row>
                        )}

                        {venta !== undefined && (
                            <>
                                {/*
                                    Cabecera del detalle.

                                    Antes eran tres cajas anidadas — `content-main` (borde naranja)
                                    adentro `content-buy` (borde gris, y con el `:hover` con brillo
                                    que hereda de `content-prod`, que aca no lleva a ningun lado) y
                                    adentro `.state` — con el titulo "Venta ID 3" suelto en otra caja
                                    mas arriba, y el estado siempre pintado de amarillo porque
                                    `h5.status` tiene el color escrito fijo.

                                    Ahora es una sola tarjeta, con el orden en que se necesita el
                                    dato: que es y de cuando, en que estado esta, cuanto es el total,
                                    y que se puede hacer. El color sale del tono del estado — el
                                    mismo del resumen y las solapas — asi que se reconoce sin leer.
                                */}
                                <header className="ventaHeader" data-tono={estadoFlujo?.tono}>
                                    <div className="ventaHeader__resumen">
                                        <div className="ventaHeader__identidad">
                                            <h2>
                                                {soyVendedorEnVenta ? "Venta" : "Compra"}{" "}
                                                <span className="ventaHeader__numero">#{venta.id}</span>
                                            </h2>
                                            {venta.createdDate && (
                                                <span className="ventaHeader__fecha">
                                                    <Moment date={venta.createdDate} format="DD/MM/YYYY HH:mm"/>
                                                </span>
                                            )}
                                        </div>

                                        <span className="ventaHeader__estado">
                                            {estadoFlujo && <FontAwesomeIcon icon={estadoFlujo.icono}/>}
                                            {ventaService.formatEstado(venta.estado)}
                                        </span>

                                        {/*
                                            La frase de ayuda esta escrita desde el lado del vendedor
                                            ("Todavia no cobraste"), asi que solo se le muestra a el.
                                        */}
                                        {soyVendedorEnVenta && estadoFlujo?.ayuda && (
                                            <p className="ventaHeader__ayuda">{estadoFlujo.ayuda}</p>
                                        )}
                                    </div>

                                    <p className="ventaHeader__total">
                                        <span className="ventaHeader__total-label">Total</span>
                                        <span className="ventaHeader__total-monto">
                                            <NumberFormat
                                                prefix={"$"}
                                                value={venta.total}
                                                displayType={"text"}
                                                thousandSeparator="."
                                                decimalSeparator=","
                                            />
                                        </span>

                                        {/*
                                            `totalLista` solo viene cargado cuando la venta tuvo alguna
                                            oferta, asi que las viejas —y las que se cerraron a precio
                                            de lista— no muestran nada de mas. El renglon dice de cuanto
                                            venia el pedido, que es la pregunta que se hace el vendedor
                                            cuando ve un total mas bajo del que esperaba.
                                        */}
                                        {venta.totalLista > venta.total && (
                                            <span className="ventaHeader__total-descuento">
                                                <s>
                                                    <NumberFormat
                                                        prefix={"$"}
                                                        value={venta.totalLista}
                                                        displayType={"text"}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                    />
                                                </s>
                                                <span>
                                                    <NumberFormat
                                                        prefix={"−$"}
                                                        value={venta.totalLista - venta.total}
                                                        displayType={"text"}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                    />
                                                    {" en ofertas"}
                                                </span>
                                            </span>
                                        )}
                                    </p>

                                    {/*
                                        Las acciones de flujo (cancelar / marcar como pagada, enviada,
                                        finalizada) y el WhatsApp quedan siempre a la vista arriba de
                                        las solapas: es lo que se toca sin importar que pestania este
                                        abierta. La que avanza el flujo es la unica `primary`; el resto
                                        no compite con ella.
                                    */}
                                    <div className="ventaHeader__acciones">
                                        {soyVendedorEnVenta &&
                                        venta.estado === ESTADO_VENTA.PENDIENTE_PAGO && (
                                            <button
                                                className="button"
                                                type="button"
                                                data-type="primary"
                                                onClick={() => this.marcarComoPagada()}
                                            >
                                                Marcar como Pagada
                                            </button>
                                        )}

                                        {soyVendedorEnVenta &&
                                        venta.estado === ESTADO_VENTA.PAGADA && (
                                            <button
                                                className="button"
                                                type="button"
                                                data-type="primary"
                                                onClick={() => this.marcarComoEnviada()}
                                            >
                                                Marcar como Enviada
                                            </button>
                                        )}

                                        {soyVendedorEnVenta &&
                                        (venta.estado === ESTADO_VENTA.PAGADA ||
                                            venta.estado === ESTADO_VENTA.PENDIENTE_ENTREGA) && (
                                            <button
                                                className="button"
                                                type="button"
                                                data-type="primary"
                                                onClick={() => this.marcarComoFinalizada()}
                                            >
                                                Marcar como Finalizada
                                            </button>
                                        )}

                                        {((soyVendedorEnVenta && !!venta.comprador.numeroCelular) ||
                                            (!soyVendedorEnVenta && !!venta.vendedor.numeroCelular)) && (
                                            <a
                                                className="button"
                                                data-type="message"
                                                target="_blank"
                                                rel="noreferrer"
                                                href={productoActions.crearLinkWhatsappVenta(venta, soyVendedorEnVenta)}
                                            >
                                                <FontAwesomeIcon icon="fa-brands fa-whatsapp" size="lg"/>
                                                {soyVendedorEnVenta
                                                    ? "Escribir al comprador"
                                                    : "Enviar tu consulta"}
                                            </a>
                                        )}

                                        {/*
                                            Cancelar es destructivo y no se deshace: va ultima y en el
                                            estilo mas discreto, para que no se toque de paso.

                                            Las condiciones no son las mismas para los dos lados y se
                                            mantienen como estaban: el vendedor puede cancelar mientras
                                            la venta siga abierta, el comprador solo antes de pagar.
                                        */}
                                        {((soyVendedorEnVenta &&
                                            venta.estado !== ESTADO_VENTA.CANCELADA &&
                                            venta.estado !== ESTADO_VENTA.FINALIZADA) ||
                                            (!soyVendedorEnVenta &&
                                                venta.estado === ESTADO_VENTA.PENDIENTE_PAGO)) && (
                                            <button
                                                className="button ventaHeader__accion--baja"
                                                type="button"
                                                data-type="complementary"
                                                onClick={() => this.cancelarVenta()}
                                            >
                                                {soyVendedorEnVenta ? "Cancelar la venta" : "Cancelar la compra"}
                                            </button>
                                        )}
                                    </div>
                                </header>

                                <div className="dashboard__content-main">
                                    {/*
                                        Antes era todo cards apiladas hasta el pie (productos en una tabla
                                        con scroll horizontal en mobile, y despues venta/compra, comprador o
                                        vendedor, comprobante y envio una debajo de la otra). Con solapas se
                                        ve una seccion a la vez, y los productos van en cards, no en tabla.
                                    */}
                                    <Tabs id="venta-detail-tabs" defaultActiveKey="productos" mountOnEnter>
                                        <Tab eventKey="productos" title={`Productos (${venta.items?.length || 0})`}>
                                            <div className="perfil__panel">
                                                {venta.items?.map((item) => (
                                                    <div className="checkout__product-item box-shadow-1" key={item.id}>
                                                        <div className="checkout__product-item-infoWrapper">
                                                            <div className="checkout__product-item-info">
                                                                <div className="checkout__product-header">
                                                                    <div className="checkout__product-title">
                                                                        <Link
                                                                            target="_blank"
                                                                            to={productoServiceTs.crearUrlProducto(item.producto)}
                                                                        >
                                                                            <h4>{item.tipoRepuesto?.nombre}</h4>
                                                                        </Link>
                                                                    </div>
                                                                    <div className="checkout__product-price">
                                                                        {item.precioLista > item.precioUnitario && (
                                                                            <s className="oferta__lista">
                                                                                <NumberFormat
                                                                                    prefix={"$"}
                                                                                    value={item.precioLista}
                                                                                    displayType={"text"}
                                                                                    thousandSeparator="."
                                                                                    decimalSeparator=","
                                                                                />
                                                                            </s>
                                                                        )}
                                                                        <NumberFormat
                                                                            prefix={"$"}
                                                                            value={item.precioUnitario}
                                                                            displayType={"text"}
                                                                            thousandSeparator="."
                                                                            decimalSeparator=","
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="checkout__product-body">
                                                                    <p>Marca: <span>{item.marca?.nombre}</span></p>
                                                                    <p>Modelo: <span>{item.modelo?.nombre}</span></p>
                                                                    {item.version?.nombre && (
                                                                        <p>Versión: <span>{item.version?.nombre}</span></p>
                                                                    )}

                                                                    {/*
                                                                        Con qué oferta se vendió este renglón. El nombre
                                                                        sale copiado de la venta y no de la tabla de
                                                                        ofertas: si la promo se renombró o se borró
                                                                        después, el pedido tiene que seguir diciendo con
                                                                        cuál se cerró.
                                                                    */}
                                                                    {item.ofertaNombre && (
                                                                        <p className="ventaItem__oferta">
                                                                            <FontAwesomeIcon icon="fa-solid fa-tag" />
                                                                            <span>
                                                                                {item.ofertaNombre}
                                                                                {item.precioLista > item.precioUnitario && (
                                                                                    <>
                                                                                        {" — "}
                                                                                        <NumberFormat
                                                                                            prefix={"$"}
                                                                                            value={redondearMonto(item.precioLista - item.precioUnitario)}
                                                                                            displayType={"text"}
                                                                                            thousandSeparator="."
                                                                                            decimalSeparator=","
                                                                                        />
                                                                                        {" de descuento"}
                                                                                    </>
                                                                                )}
                                                                            </span>
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </Tab>

                                        <Tab eventKey="pago" title="Pago">
                                            <div className="perfil__panel">
                                                <h4>Datos de la {soyVendedorEnVenta ? 'Venta' : 'Compra'}</h4>
                                                <div className="dashboard__content-buy">
                                                    <div className="seller-data">
                                                        <div>
                                                            Medio de Pago:&nbsp;
                                                            <span>
                                                                {venta.medioPago}
                                                            </span>
                                                        </div>
                                                        {(soyVendedorEnVenta && venta.medioPago == MEDIO_PAGO.MERCADO_PAGO) && <div>
                                                            Comision Mercado Pago:
                                                            <span>
                                                                <NumberFormat prefix={"$"} value={venta.comision} displayType={"text"} thousandSeparator="." decimalSeparator=","/>
                                                            </span>
                                                        </div>}
                                                        {(soyVendedorEnVenta && venta.medioPago == MEDIO_PAGO.MERCADO_PAGO && venta.montoNeto != null) && <div>
                                                            Te acredita Mercado Pago:
                                                            <span>
                                                                <NumberFormat prefix={"$"} value={venta.montoNeto} displayType={"text"} thousandSeparator="." decimalSeparator=","/>
                                                            </span>
                                                        </div>}

                                                        <div>
                                                        {!venta.hasReview && !soyVendedorEnVenta && (
                                                                                <button
                                                                                    data-type="primary"
                                                                                    className="button"
                                                                                    onClick={(e) => this.addReview(venta)}
                                                                                >
                                                                                    Comenta tu experiencia
                                                                                </button>
                                                                            )}

                                                        {venta.hasReview && (
                                                            <button
                                                                data-type="primary"
                                                                className="button"
                                                                onClick={(e) => this.viewReview(venta)}
                                                            >
                                                                Ver reseña
                                                            </button>
                                                        )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {venta.medioPago === MEDIO_PAGO.TRANSFERENCIA && (
                                                    <>
                                                        <h4>Comprobante de transferencia</h4>
                                                        <div className="dashboard__content-buy">
                                                            <ComprobanteTransferencia
                                                                venta={venta}
                                                                esVendedor={soyVendedorEnVenta}
                                                                onSubido={this.setComprobante}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </Tab>

                                        <Tab eventKey="contacto" title="Contacto">
                                            <div className="perfil__panel">
                                                {soyVendedorEnVenta && <>
                                                    <h4>Datos del comprador</h4>
                                                    <div className="dashboard__content-buy">
                                                        <div className="seller-data">
                                                            <div>
                                                                Nombre:
                                                                <span>
                                              {venta.comprador.firstName + " " + venta.comprador.lastName}
                                            </span>
                                                            </div>

                                                            <div>
                                                                Username: <span>{venta.comprador.username}</span>
                                                            </div>

                                                            <div>
                                                                Mail: <span>{venta.comprador.email}</span>
                                                            </div>

                                                            <div>
                                                                Celular: <span>{venta.comprador.numeroCelular}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>}

                                                {!soyVendedorEnVenta && <>
                                                    <h4>Datos del vendedor</h4>
                                                    <div className="dashboard__content-buy">
                                                        <div className="seller-data">
                                                            <div>
                                                                Nombre:
                                                                <span>
                                              {venta.vendedor.firstName + " " + venta.vendedor.lastName}
                                            </span>
                                                            </div>

                                                            {venta.medioPago === MEDIO_PAGO.TRANSFERENCIA &&
                                                            <>
                                                                <h5>Datos para realizar la transferencia</h5>
                                                                <div>
                                                                    Alias: <span>{venta.vendedor.alias}</span>
                                                                </div>
                                                                <div>
                                                                    CBU: <span>{venta.vendedor.cbu}</span>
                                                                </div>
                                                            </>
                                                            }

                                                            <div>
                                                                Username: <span>{venta.vendedor.username}</span>
                                                            </div>

                                                            <div>
                                                                Mail: <span>{venta.vendedor.email}</span>
                                                            </div>

                                                            <div>
                                                                Celular: <span>{venta.vendedor.numeroCelular}</span>
                                                            </div>

                                                            <div>
                                                                Dirección:
                                                                <span>
                                              {venta.vendedor.direccion} - {""}
                                                                    {venta.vendedor.ciudad} - {""}
                                                                    {venta.vendedor.codigoPostal} - {""}
                                                                    {venta.vendedor.provincia?.nombre}
                                            </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>}

                                                <h4>Información Envio</h4>
                                                <div className="dashboard__content-buy">
                                                    <div className="delivery-data">
                                                        {venta.tipoEnvio == TIPO_ENVIO.SIN_ENVIO && (
                                                            <div>SIN ENVIO</div>
                                                        )}

                                                        {venta.tipoEnvio == TIPO_ENVIO.ENVIO_A_COORDINAR && (
                                                            <>
                                                                <div>Envio a Coordinar con el vendedor.</div>
                                                                <div>
                                                                    Dirección Envio:
                                                                    <p>
                                                                        {venta.direccion} - {""}
                                                                        {venta.ciudad} - {""}
                                                                        {venta.codigoPostal} - {""}
                                                                        {venta.provincia.nombre}
                                                                    </p>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab>

                                        {soyVendedorEnVenta && this.state.facturacionHabilitada && (
                                            <Tab eventKey="factura" title="Factura">
                                                <div className="perfil__panel">
                                                    <FacturaVenta venta={venta}/>
                                                </div>
                                            </Tab>
                                        )}
                                    </Tabs>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <Modal size="md" show={this.state.showReview} onHide={this.state.readonly? this.handleCloseReview:this.handleClose}>
                    <Modal.Header closeButton>
                        {this.state.readonly
                            ? "Reseña"
                            : "Recomenda al vendedor por esta compra!"}
                    </Modal.Header>
                    <Modal.Body>
                        <ReviewModal
                            handleClose={this.state.readonly? this.handleCloseReview:this.handleClose}
                            readonly={this.state.readonly}
                            venta={this.state.venta}
                        />
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

function mapState(state) {
    const {} = state;
    return {};
}

const actionCreators = {
    seleccionarProducto: busquedaActions.buscarYSeleccionarProducto
};

const connectedCompraDetail = connect(mapState, actionCreators)(CompraDetail);
export {connectedCompraDetail as CompraDetail};
